import { takeEvery, call, put, fork } from "redux-saga/effects";
import * as actions from "../actions/PlannedMaintenanceDetailActions";
import * as api from "../../api/PlannedMaintenanceDetailApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { getFilesFromZip } from "../../common";

function* setTaskDetailById(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.setTaskDetailById(action.payload);
        yield put(actions.setTaskDetailById(data || undefined));
    } catch (error) {
        yield put(actions.setTaskDetailById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEkedEquipmentList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getEkedEquipmentList(action.payload);
        yield put(actions.setEkedEquipmentList(data || undefined));
    } catch (error) {
        yield put(actions.setEkedEquipmentList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateEkedEquipmentList(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateEkedEquipmentList(action.payload);
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(actions.updateEkedEquipmentList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getSameLevelListById(action) {
    try {
        const { data } = yield api.getSameLevelListById(action.payload);
        yield put(actions.setSameLevelListById(data || undefined));
    } catch (error) {
        yield put(actions.setSameLevelListById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getbreakdownRootCause(action) {
    try {
        const { data } = yield api.getbreakdownRootCause(action.payload);
        yield put(actions.setbreakdownRootCause(data || undefined));
    } catch (error) {
        yield put(actions.setbreakdownRootCause(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPoolList(action) {
    try {
        const { data } = yield api.getPoolList(action.payload);
        if (action.payload.loadEditRequestData) {
            yield put(actions.setPoolList(data || undefined));
            yield put(actions.getBreakdownReasonGroupList({ loadEditRequestData: true }));
        }
    } catch (error) {
        yield put(actions.setPoolList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakdownReasonGroupList(action) {
    try {
        const { data } = yield api.getBreakdownReasonGroupList(action.payload);
        if (action.payload.loadBreakdownReasonGroup) {
            data["loadBreakdownReasonGroup"] = true;
            yield put(actions.setBreakdownReasonGroupList(data || undefined));
        }
        if (action.payload.loadEditRequestData) {
            data["loadEditRequestData"] = true;
            yield put(actions.setBreakdownReasonGroupList(data || undefined));
            yield put(actions.getBreakdownEffectList());
        }
    } catch (error) {
        yield put(actions.setBreakdownReasonGroupList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakdownEffectList(action) {
    try {
        const { data } = yield api.getBreakdownEffectList(action.payload);
        yield put(actions.setBreakdownEffectList(data || undefined));
        yield put(actions.resetBreakDownEffectsList());
    } catch (error) {
        yield put(actions.setBreakdownEffectList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getTechnicianListByPoolId(action) {
    try {
        const { data } = yield api.getTechnicianListByPoolId(action.payload);
        yield put(actions.setTechnicianListByPoolId(data || undefined));
    } catch (error) {
        yield put(actions.setTechnicianListByPoolId(undefined));
        yield put(showErrorSnackbar(error));
    }
}

function* plannedMaintenanceAssign(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.plannedMaintenanceAssign(action.payload);
        yield put(actions.setPlannedMaintenanceAssign(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setPlannedMaintenanceAssign(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlannedMintenance(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getPlannedMintenance(action.payload);
        yield put(actions.setPlannedMaintenance(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setPlannedMaintenance(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* plannedMaintenanceCloaseComplete(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.plannedMaintenanceCloaseComplete(action.payload);
        yield put(actions.setPlannedMaintenanceCloaseComplete(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setPlannedMaintenanceCloaseComplete(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* plannedMaintenancePause(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.plannedMaintenancePause(action.payload);
        yield put(actions.setplannedMaintenancePause(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setplannedMaintenancePause(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* plannedMaintenanceUpdateTask(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.plannedMaintenanceUpdateTask(action.payload);
        yield put(actions.setplannedMaintenanceUpdateTask(data || undefined));
        yield put(actions.resetplannedMaintenanceUpdateTask());
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setplannedMaintenanceUpdateTask(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* AddTechnician(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.AddTechnician(action.payload);
        yield put(actions.setAddTechnician(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setAddTechnician(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* BreakdownReasonPlaceByGroupId(action) {
    try {
        const { data } = yield api.BreakdownReasonPlaceByGroupId(action.payload);
        yield put(actions.setBreakdownReasonPlaceByGroupId(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownReasonPlaceByGroupId(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* BreakdownReasonDetail(action) {
    try {
        const { data } = yield api.BreakdownReasonDetail(action.payload);
        yield put(actions.setBreakdownReasonDetail(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownReasonDetail(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlannedFiles(action) {
    try {
        const { data } = yield api.getPlannedFiles(action.payload);
        const files = yield getFilesFromZip(data);
        yield put(actions.setPlannedFiles(files || undefined));
    } catch (error) {
        yield put(actions.setPlannedFiles(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addPlannedFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.addPlannedFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* MaintenancePauseReason(action) {
    try {
        const { data } = yield api.MaintenancePauseReason(action.payload);
        yield put(actions.setMaintenancePauseReason(data || undefined));
    } catch (error) {
        yield put(actions.setMaintenancePauseReason(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getTaskHistoryById(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getTaskHistoryById(action.payload);
        yield put(actions.setTaskHistoryById(data || undefined));
    } catch (error) {
        yield put(actions.setTaskHistoryById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteTask(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deleteTask(action.payload);
        yield put(actions.setDeleteTask(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setDeleteTask(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deletePlannedFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deletePlannedFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_TASKS_DETAIL_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL, setTaskDetailById);
    yield takeEvery(actions.Types.GET_SAME_LEVEL_LIST_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL, getSameLevelListById);
    yield takeEvery(actions.Types.GET_EKED_EQUIPMENT_LIST_PLANNED, getEkedEquipmentList);
    yield takeEvery(actions.Types.UPDATE_EKED_EQUIPMENT_LIST_PLANNED, updateEkedEquipmentList);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_ROOT_CAUSE_IN_PLANNED_MAINTENANCE_DETAIL, getbreakdownRootCause);
    yield takeEvery(actions.Types.GET_POOL_LIST_FOR_MAITENANCE_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL, getPoolList);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_Effect_LIST_IN_PLANNED_MAINTENANCE_DETAIL, getBreakdownEffectList);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_REASON_GROUP_LIST_IN_PLANNED_MAINTENANCE_DETAIL, getBreakdownReasonGroupList);
    yield takeEvery(actions.Types.GET_TECHNICAL_LIST_BY_POOL_ID_IN_PLANNED_MAINTENANCE_DETAIL, getTechnicianListByPoolId);
    yield takeEvery(actions.Types.PLAN_MAINTENANCE_ASSIGN_TASK_IN_PLANNED_MAINTENANCE_DETAIL, plannedMaintenanceAssign);
    yield takeEvery(actions.Types.GET_PLANNED_MAINTENANCE_PLAY_START_IN_PLANNED_MAINTENANCE_DETAIL, getPlannedMintenance);
    yield takeEvery(actions.Types.PLANNED_MAINTENANCE_CLOSE_COMPLETE_IN_PLANNED_MAINTENANCE_DETAIL, plannedMaintenanceCloaseComplete);
    yield takeEvery(actions.Types.PLANNED_MAINTENANCE_PAUSE_IN_PLANNED_MAINTENANCE_DETAIL, plannedMaintenancePause);
    yield takeEvery(actions.Types.PLANNED_MAINTENANCE_UPDATE_TASK_IN_PLANNED_MAINTENANCE_DETAIL, plannedMaintenanceUpdateTask);
    yield takeEvery(actions.Types.ADD_TECHNICIANS_IN_PLANNED_MAINTENANCE_DETAIL, AddTechnician);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST_IN_PLANNED_MAINTENANCE_DETAIL, BreakdownReasonPlaceByGroupId);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_REASON_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL, BreakdownReasonDetail);
    yield takeEvery(actions.Types.GET_PLANNED_FILES, getPlannedFiles);
    yield takeEvery(actions.Types.ADD_PLANNED_FILES, addPlannedFiles);
    yield takeEvery(actions.Types.MAINTENANCE_PAUSE_REASON_IN_PLANNED_MAINTENANCE_DETAIL, MaintenancePauseReason);
    yield takeEvery(actions.Types.GET_TRACK_HISTORY_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL, getTaskHistoryById);
    yield takeEvery(actions.Types.DELEET_TASK_IN_PLANNED_MAINTENANCE_DETAIL, deleteTask);
    yield takeEvery(actions.Types.DELETE_PLANNED_FILES, deletePlannedFiles);
}
const PlannedMaintenanceDetailSaga = [fork(watchAll)];

export default PlannedMaintenanceDetailSaga;
